<template>
  <v-toolbar flat color="transparent">
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nueva"
      iconText="mdi-plus"
      tipo="agregar"
      @click="crearActividad">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ActividadesToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    crearActividad() {
      this.$emit('crearActividad');
    },
  },
};
</script>

<style lang="scss">

</style>
